import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { LOGO_ICON, ROUTE_CONTACT } from "@/lib/brand";

export const CTA = () => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 lg:py-32"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 backdrop-blur-xl px-8 py-16 md:px-16 md:py-24 text-center">
            {/* glows */}
            <div className="pointer-events-none absolute inset-0 -z-10">
              <div className="absolute -top-20 left-1/4 w-96 h-96 rounded-full bg-brand-orange/25 blur-[130px]" />
              <div className="absolute -bottom-24 right-1/4 w-96 h-96 rounded-full bg-brand-blue/25 blur-[130px]" />
            </div>

            <img
              src={LOGO_ICON}
              alt="MatchGate"
              className="mx-auto w-16 h-16 object-contain mb-8 animate-float drop-shadow-[0_0_20px_rgba(255,107,0,0.5)]"
            />

            <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl lg:text-7xl leading-[0.95] max-w-4xl mx-auto">
              Bereit, durch das{" "}
              <span className="gradient-text">Gate</span> zu gehen?
            </h2>
            <p className="mt-6 max-w-xl mx-auto text-base md:text-lg leading-relaxed text-white/60">
              Ein Abo, alle Funktionen eurer Seite. Eine Provision von 5 % nur
              dann, wenn tatsächlich ein Vertrag zustande kommt.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to={ROUTE_CONTACT}
                data-testid="cta-club-button"
                className="group inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-bold text-white bg-gradient-to-r from-brand-orange to-brand-blue shadow-[0_0_40px_-6px_rgba(255,107,0,0.7)] hover:shadow-[0_0_50px_-4px_rgba(0,122,255,0.8)] hover:scale-[1.04] transition-all duration-300"
              >
                Kontakt aufnehmen
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
              </Link>
              <Link
                to="/preisstruktur"
                data-testid="cta-sponsor-button"
                className="inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-semibold text-white/85 border border-white/15 bg-white/[0.02] hover:bg-white/[0.06] hover:text-white transition-all duration-300"
              >
                Preise ansehen
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
